var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.376 7.293-7.12 7.12a.85.85 0 0 0-.256.624.85.85 0 0 0 .257.623l.807.808a.85.85 0 0 0 .624.257.738.738 0 0 0 .624-.22L12 10.816l5.688 5.688c.171.172.38.245.624.22a.85.85 0 0 0 .624-.256l.807-.808a.85.85 0 0 0 .257-.623.85.85 0 0 0-.257-.624l-7.12-7.12A.8.8 0 0 0 12 7a.8.8 0 0 0-.624.293Z"
  })));
};
export default SvgChevronUp;